// extracted by mini-css-extract-plugin
export var modalFooter = "_px-0";